import React from "react";
import { Menu } from "./components/Menu";
import { Outlet } from "react-router-dom";
import SEO from "../../components/SEO";

const MyAccount = () => {
  return (
    <>
      <SEO 
        title="Minha Conta - Área do Cliente | Grupo Terra"
        description="Gerencie sua conta, visualize histórico de pedidos, colaboradores e informações de pagamento e entrega."
        keywords="minha conta, área do cliente, pedidos, histórico"
      />
      <div className="liton__wishlist-area pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="ltn__product-tab-area">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="ltn__tab-menu-list mb-50">
                      <Menu />
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="tab-content">
                      <Outlet />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default MyAccount;
